import React from 'react';

import SvgCard from '../svg-card/svg-card';
import { SvgCardType } from '../svg-card/svg-card-types';

import './header.scss';

interface HeaderProps {
    title: string;
    subtitle?: string;
    svgCardType?: SvgCardType;
    showSubtitle?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ title, subtitle, svgCardType, showSubtitle = true }) => (
    <div className="header-container container__standard-width">
        {svgCardType && <SvgCard type={svgCardType} />}
        <h1 className="light">{title}</h1>
        {showSubtitle && subtitle && <h2>{subtitle}</h2>}
    </div>
);
